import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose } from 'redux';

import { Loader, Paper } from 'redpoints-front-components/index';

import {
  incidentDetailsClear,
  incidentDetailsFetchAccountPermissions,
  incidentDetailsFetchEvidencePermissions,
  incidentDetailsFetchIncidentData,
  incidentDetailsFetchLinkDataPermissions,
  incidentDetailsFetchSellerPermissions,
} from '../../../actions/incidentDetailsActions';
import { getIncidentDetailsDataIsLoading } from '../../../reducers/reporting/incidentDetails';
import IncidentDetailsActions from './IncidentDetailsActions';
import IncidentDetailsHeader from './IncidentDetailsHeader';
import IncidentDetailsLinkData from './IncidentDetailsLinkData';

const IncidentDetails = ({
  incidentDetailsClear,
  incidentDetailsFetchAccountPermissions,
  incidentDetailsFetchEvidencePermissions,
  incidentDetailsFetchIncidentData,
  incidentDetailsFetchLinkDataPermissions,
  incidentDetailsFetchSellerPermissions,
  isLoading,
  context,
  match: {
    params: { assetId, incidentId },
  },
}) => {
  useEffect(() => {
    incidentDetailsFetchIncidentData({ assetId, incidentId });
    incidentDetailsFetchAccountPermissions();
    incidentDetailsFetchEvidencePermissions();
    incidentDetailsFetchLinkDataPermissions();
    incidentDetailsFetchSellerPermissions();
  }, [
    assetId,
    incidentDetailsFetchEvidencePermissions,
    incidentDetailsFetchAccountPermissions,
    incidentDetailsFetchIncidentData,
    incidentDetailsFetchLinkDataPermissions,
    incidentDetailsFetchSellerPermissions,
    incidentId,
  ]);

  useEffect(() => {
    return () => incidentDetailsClear();
  }, [incidentDetailsClear]);

  return (
    <Loader isLoading={isLoading}>
      <section className="incident-details-container">
        <Paper>
          <IncidentDetailsHeader />
        </Paper>
        <Paper className="mt-20">
          <IncidentDetailsLinkData />
          <IncidentDetailsActions context={context} />
        </Paper>
      </section>
    </Loader>
  );
};

const mapStateToProps = state => ({
  isLoading: getIncidentDetailsDataIsLoading(state),
});

export default compose(
  connect(mapStateToProps, {
    incidentDetailsClear,
    incidentDetailsFetchEvidencePermissions,
    incidentDetailsFetchIncidentData,
    incidentDetailsFetchLinkDataPermissions,
    incidentDetailsFetchAccountPermissions,
    incidentDetailsFetchSellerPermissions,
  }),
  withRouter
)(IncidentDetails);
